import { fetchApi } from '@/config/axiosSetting.ts';

type ResponseType = Promise<
  { id: number; name: string }[]
>;
export const provinceRequest = ({
  province,
}: {
  province: string | null;
}): ResponseType =>
  fetchApi({
    method: 'GET',
    url: 'selection_item/province/wop_list/',
    params: { name: province },
  });
